import {
  setThemeToLocalStorage,
  setIntroductionTooltipToLocalStorage
} from 'utils/localStorageUtil'
import { sendMessage } from 'utils/iframeUtil'
import { setMemorizedStateToSessionStorage } from 'utils/sessionStorageUtils'
import { getDashboard } from './dashboard/asyncThunks'

const selectMemorizedStateForV4 = (state) => {
  const { sort, filter, selectedLabels, category } = state.accessibleDashboards
  const { dashboardViewLayout } = state.ui

  return {
    accessibleDashboards: {
      sort,
      filter,
      selectedLabels,
      category
    },
    ui: {
      dashboardViewLayout
    }
  }
}

const applicationMiddleware = ({ getState }) => (next) => (action) => {
  const returnValue = next(action)
  const state = getState()

  switch (action.type) {
    case getDashboard.fulfilled.type: {
      break
    }
    case 'ui/setDisplayTheme':
      setThemeToLocalStorage(action.payload)
      break
    case 'ui/setPresentationMode':
      sendMessage({ type: 'v4PresentationMode', data: action.payload })
      break
    case 'ui/setIntroductionToolTips':
      Object.keys(action.payload).forEach((key) => {
        setIntroductionTooltipToLocalStorage({ storageKey: key, isRead: action.payload[key] })
      })
      break
    case 'dashboard/deleteDashboard/fulfilled':
      sendMessage({ type: 'v4DashboardHome' })
      break
    case 'dashboard/copyDashboard/fulfilled':
      sendMessage({ type: 'goToEdit', data: action.payload.dashboardId })
      break
    case 'dashboardInfo/setFilter':
    case 'dashboardInfo/setFilterKeyWord':
    case 'dashboardInfo/setCategory':
      setMemorizedStateToSessionStorage(selectMemorizedStateForV4(state))
      break

    default:
  }
  return returnValue
}

export default applicationMiddleware
